@if (isLoading()) {
  <ngx-skeleton-loader
    class="custom-skeleton"
    [count]="1"
    animation="pulse"
    appearance="line"
    [theme]="{height: '40px', 'margin-bottom': '1rem', background: 'var(--skeleton-color)'}"
  />

  <div class="row">
    @for (_ of [].constructor(4); track $index) {
      <div class="col-md-6 col-xl-3">
        <ngx-skeleton-loader
          class="custom-skeleton"
          [count]="1"
          animation="pulse"
          appearance="line"
          [theme]="{height: '124px', 'margin-bottom': '1rem', background: 'var(--skeleton-color)'}"
        />
      </div>
    }
  </div>

  <ngx-skeleton-loader
    class="custom-skeleton"
    [count]="1"
    animation="pulse"
    appearance="line"
    [theme]="{height: '400px', 'margin-bottom': '2rem', background: 'var(--skeleton-color)'}"
  />
} @else {
  <div class="mb-3">
    <a class="fs-4" [routerLink]="[Resources.Properties]" ngbTooltip="{{ 'MENU.PROPERTIES' | translate }}">
      <i class="las la-arrow-left"></i>
      {{ 'METER.PROPERTY' | translate }} -
      {{ data().name }}
    </a>
  </div>

  <!--  <property-info [property]="data()"/>-->

  <div class="mb-3">
    <personal-property-info [data]="data()">
      <button *ngCan="'buildings.update'" class="btn btn-primary btn-sm align-self-start" (click)="update()">
        <i class="las la-pen fs-18 align-middle"></i>
        {{ 'PROPERTY.UPDATE_PROPERTY' | translate }}
      </button>
    </personal-property-info>
  </div>

  <div class="row">
    <div class="col-12 col-md-6 col-xl-3 mb-4">
      <card
        [title]="translateService.instant('APARTMENT.CURRENT_RENTAL_INCOME')"
        [popoverTitle]="translateService.instant('APARTMENT.CURRENT_RENTAL_INCOME')"
        [popoverDesc]="translateService.instant('APARTMENT.CURRENT_RENTAL_INCOME_DESC')"
        icon="ri-currency-line"
        [profitType]="data()?.currentRentalIncome?.direction"
        [profit]="data()?.currentRentalIncome?.percent"
        [subtext]="translateService.instant('APARTMENT.MONTHLY')"
        [value]="data()?.currentRentalIncome?.rentalIncome"
        valueType="euro"
        [period]="translateService.instant(data()?.currentRentalIncome?.direction ? 'APARTMENT.MORE' : 'APARTMENT.LESS')"
        iconColor="primary"
        [isLoading]="isLoading()"
      />
    </div>

    <div class="col-12 col-md-6 col-xl-3 mb-4">
      <card
        [title]="translateService.instant('DASHBOARD.MAXIMUM_RENTAL_INCOME')"
        [popoverTitle]="translateService.instant('DASHBOARD.MAXIMUM_RENTAL_INCOME')"
        [popoverDesc]="translateService.instant('DASHBOARD.MAXIMUM_RENTAL_INCOME_DESC')"
        icon="ri-exchange-dollar-line"
        [profitType]="data()?.maximumRentalIncome?.direction"
        [profit]="data()?.maximumRentalIncome?.percent"
        [subtext]="translateService.instant('APARTMENT.MONTHLY')"
        [value]="data()?.maximumRentalIncome?.rentalMaximum"
        valueType="euro"
        [period]="translateService.instant(data()?.maximumRentalIncome?.direction ? 'APARTMENT.MORE' : 'APARTMENT.LESS')"
        iconColor="primary"
        [isLoading]="isLoading()"
      />
    </div>

    <div class="col-12 col-md-6 col-xl-3 mb-4">
      <card
        [title]="translateService.instant('DASHBOARD.OPERATING_COSTS')"
        [popoverTitle]="translateService.instant('DASHBOARD.OPERATING_COSTS')"
        [popoverDesc]="translateService.instant('DASHBOARD.OPERATING_COSTS_DESC')"
        icon="ri-time-line"
        [profitType]="data()?.operatingCosts?.direction"
        [profit]="data()?.operatingCosts?.percent"
        [subtext]="translateService.instant('APARTMENT.MONTHLY')"
        [value]="data()?.operatingCosts?.operatingCosts"
        valueType="euro"
        [period]="translateService.instant(data()?.operatingCosts?.direction ? 'APARTMENT.MORE' : 'APARTMENT.LESS')"
        iconColor="primary"
        [isLoading]="isLoading()"
      />
    </div>

    <div class="col-12 col-md-6 col-xl-3 mb-4">
      <card
        [title]="translateService.instant('DASHBOARD.BILLED_ADDITIONAL_COSTS')"
        [popoverTitle]="translateService.instant('DASHBOARD.BILLED_ADDITIONAL_COSTS')"
        [popoverDesc]="translateService.instant('DASHBOARD.BILLED_ADDITIONAL_COSTS_DESC')"
        icon="ri-time-line"
        [profitType]="data()?.billedAdditionalCosts?.direction"
        [profit]="data()?.billedAdditionalCosts?.percent"
        [subtext]="translateService.instant('APARTMENT.MONTHLY')"
        [value]="data()?.billedAdditionalCosts?.additionalCosts"
        valueType="euro"
        [period]="translateService.instant(data()?.billedAdditionalCosts?.direction ? 'APARTMENT.MORE' : 'APARTMENT.LESS')"
        iconColor="primary"
        [isLoading]="isLoading()"
      />
    </div>
  </div>

  <div class="d-flex justify-content-start">
    <ul class="nav nav-tabs-custom mb-3">
      @for (tab of tabs; track $index) {
        @if (tab.id !== TabId.OBJECTDATA) {
          <li class="nav-item">
            <a
              class="nav-link cursor-pointer"
              [class.active]="activeTab === tab.id"
              (click)="selectTab(tab)"
            >
              <i [ngClass]="tab.iconClass" class="me-1"></i>
              <span class="fs-17">{{ tab.titleKey | translate }}</span>
            </a>
          </li>
        }
      }

      <li class="nav-item" *ngCanRole="[Roles.ADMIN,Roles.OWNER, Roles.COMPANY_GROUP_MANAGER, Roles.COMPANY_MANAGER]">
        <a
          class="nav-link cursor-pointer"
          [class.active]="activeTab === TabId.OBJECTDATA"
          (click)="selectTab({
        id: TabId.OBJECTDATA,
        titleKey: 'PROPERTY.OBJECT_DATA',
        iconClass: 'la la-user'
      })"
    >
          <i class="la la-user me-1"></i>
          <span class="fs-17">{{ 'PROPERTY.OBJECT_DATA' | translate }}</span>
        </a>
      </li>
    </ul>
  </div>

  @switch (activeTab) {
    @case (TabId.UNITS) {
      <app-property-apartments [property]="data()" (reloadProperty)="loadData()"/>
    }
    @case (TabId.CONTRACTS) {
      <contracts [property]="data()" (successEvent)="loadData()"/>
    }
    @case (TabId.MAINTENANCE) {
      <app-property-maintenance/>
    }
    @case (TabId.ENERGY) {
      <app-property-energy/>
    }
    @case (TabId.OBJECTDATA) {
      <app-object-resposible [property]="data()"/>
    }
    @case (TabId.CONFIGURATION) {
      <app-configuration-providers [property]="data()"/>
    }
    @case (TabId.COUNTER) {
      <app-meters [property]="data()"/>
    }
    @case (TabId.DOCUMENT) {
      <app-documents
        [hideActions]="true"
        [buildingId]="data().id"
      />
    }
  }
}
